import React from 'react';
import { Spin } from 'antd';

const Loading = () => (
  <Spin style={{
    width: '75%',
    height: '100%',
    position: 'absolute',
    top: '10px',
    left: '100px',
    transform: 'translateY(50%)',
  }}
  />
);

export default Loading;
